import { Alert } from '@components/alert/Alert';
import { AlertStatus } from '@models/alert';
import { getAppEnvironment } from '@/config';

export const ApiEnvBanner = () => {
  return window.lio.getApiEnvironment() !== getAppEnvironment() ? (
    <Alert
      id='api-env-banner'
      type={AlertStatus.Info}
      ctaText='Align environment'
      ctaFunction={() => {
        window.lio.setApiEnvironment(getAppEnvironment());
      }}
      sx={{
        position: 'sticky',
      }}
    >
      You are currently using {window.lio.getApiEnvironment()} api environment. Click the link to use{' '}
      {getAppEnvironment()} environment.
    </Alert>
  ) : null;
};
